import { baseApi } from 'common/store/baseApi';
import { apiRootUrl } from 'common/utils/network/endpoints';

type DashboardTourBody = {
  dashboard_tour: { completed_at: string; version: number };
};

export const shepherdApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    saveDashboardTour: builder.mutation<{ saved: boolean }, DashboardTourBody>({
      query: (body) => ({
        url: `${apiRootUrl}/user/onboarding-profile`,
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

export const { useSaveDashboardTourMutation } = shepherdApi;
